<template>
<!-- 拟建项目 -->
    <div class="contain desPro nijian-ent">
        <div class="header-box">
            我的项目
        </div>
        <div class="box">
            <div class="build-bar">
                <span>项目名称：</span>
                <el-input placeholder="请输入项目名称" v-model="search.name" style="width:12vw;"></el-input>
                <el-button type="primary" class="add-user" @click="doFilter" style="margin-left:1vw;">查询</el-button>
                <el-button type="primary" class="add-user" @click="addFun">项目创建</el-button>
            </div>
            <div class="box-content">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="位置">
                        <template slot-scope="scope">
                            <span>{{ scope.row.address }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目概况">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="效果图">
                        <template slot-scope="scope">
                            <el-image v-for="item in scope.row.imgList" :key="item" style="width: 50px; height: 50px" :src="item" :preview-src-list="scope.row.imgList"></el-image>
                            <!-- <span>{{ scope.row.remarks }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.userName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                            <el-button type="text" style="color:#E6A23C;" @click="modeFun(scope.$index, scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                style="padding-top:10px;"
                ></el-pagination>


                <el-dialog
                    :title="diaTitle"
                    :visible.sync="addFormVisible"
                    width="600px"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                >
                    <el-form :model="addForm" ref="addForm" :rules="rules" label-width="150px" :label-position="labelPosition">
                        <el-form-item label="项目名称：" prop="name">
                            <el-input v-model="addForm.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="所属区域：">
                            <el-cascader
                                :props="{value:'id',label:'name'}"
                                :options="areas"
                                v-model="selectedOptions"
                                change-on-select="true"
                            ></el-cascader>
                            <!-- <el-input v-model="addForm.address" autocomplete="off"></el-input> -->
                        </el-form-item>
                        <el-form-item label="项目概况：">
                            <el-input type="textarea" :rows="2" v-model="addForm.note" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="效果图：">
                            <el-upload
                                v-bind:action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:205}"
                                list-type="picture-card"
                                :file-list="fileList"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove"
                                :on-success="fileSuccess">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="项目负责人：">
                          <el-select v-model="addForm.projectHead" placeholder="请选择" class="tqmInfo-val" >
                            <el-option
                               v-for="item in projects1"
                               :key="item.userId"
                               :label="item.name"
                               :value="item.userId">
                             </el-option>
                           </el-select>
                        </el-form-item> 
                        <el-form-item label="项目类型：">
                            <el-select v-model="addForm.projectType" placeholder="请选择" class="tqmInfo-val">
                             <el-option
                               v-for="item in Type"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                             </el-option>
                           </el-select>
                        </el-form-item>
                        <el-form-item label="详细地址：">
                            <el-input v-model="addForm.address" autocomplete="off" @change="setMapPoint"></el-input>
                        </el-form-item>
                        <el-form-item label="项目位置：">
                            <div style="width:100%;height:300px;">
                                <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%;width:100%;" @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
                            </div>
                            </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            search:{
                name:'',
                projectHead:'',
            },
            listData:[],
            groupId:"",
            num:{},
            dataText:"数据加载中...",
            addFormVisible:false,
            addForm: {
                id:'',
                name:'',
                address:'',
                userId:'',
                userName:'',
                groupId:'',
                note:'',
                effectImage:'',
                projectStatus:'1',
                projectType:'',
                areaId:'',
                gpsPoint:'',
                maintenanceType:'1',
                projectHead:'',
            },
            rules:{
                name: [
                { required: true, message: '请输入相应内容', trigger: 'blur' }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            diaTitle:"创建项目",
            labelPosition: 'right',
            dialogImageUrl: '',
            dialogVisible: false,
            imgList:[],
            uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
            uploadHead: {
                //上传接口header参数
                accessToken: this.$store.state.token
            },
            fileList:[],
            Status:[],
            Type:[],
            areas:[],//区域列表
            selectedOptions:[],//所属的区域
            //地图
            center: {lng: 117.283334, lat: 31.866339},
            zoom: 13,
            map:{},
            geoc:{},
            searchInput:'',
            local:'',//本地地图查询
            projects1:[],//项目负责人列表
            
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.search.projectHead = util.session.get('user').id
        this.getData()
        this.getArea()
        this.getPerson()
    },
    methods:{
        /**获取负责人 */
        getPerson(){
            var that =this
            myHttp.selectEntPersonList({
                entId:this.groupId 
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.entPersonList||[]
                    that.projects1 =list
                }
            })
        },
        //获取区域
        getArea() {
            var that = this
            myHttp.getAreaList().then(
                function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.areaList
                    var tree = util.common.listToTree('id', 'parentId', list)
                    that.areas = tree
                } else {
                    that.$message.error(resp.data.msg)
                }
                },
                function() {}
            )
        },
        doFilter(){
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //点击过滤
        showProjectFun(index){
            this.search.unit = index
            this.getData()
        },
        //获取数据
        getData(){
            var that = this
            this.search.groupId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            this.search.projectHead = util.session.get('user').id
            myHttp.getEntProjectList(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entProject.list;
                    for(var i=0;i<list.length;i++){
                        list[i].index = list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        var img = list[i].effectImage&&list[i].effectImage!=''?list[i].effectImage.split(','):[]
                        for(var j=0;j<img.length;j++){
                            img[j] = base.httpCtx+img[j]
                        }
                        list[i].imgList = img
                    }
                    that.listData = list;
                    that.totalItems = resp.data.data.entProject.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }
            })
        },
        //获取区域
        setAreaFun(id) {
            if ('' == id || undefined == id) return
            var that = this
            myHttp.getAreaById({
                id: id
            }).then(
                function(resp) {
                    if (resp.data.code == '200') {
                        var province = resp.data.data.area.provinceId
                        var city = resp.data.data.area.cityId
                        var area = resp.data.data.area.countyId
                        if (resp.data.data.area.level == '3' && undefined == area) {
                            area = resp.data.data.area.id
                        }
                        var arry = []
                        arry.push(province)
                        arry.push(city)
                        arry.push(area)
                        that.selectedOptions = arry
                    }
                },
                function(error) {}
            )
        },
        //解析图片
        setImg(str){
            if(str&&str!=''){
                var list = str.split(',')
                var result = []
                for(var i=0;i<list.length;i++){
                    var obj = {
                        uid:i,
                        baseUrl:list[i],
                        url:base.httpCtx+list[i]
                    }
                    result.push(obj)
                }
                return result
            }else{
                return []
            }
        },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            // this.$router.push('/desFile/'+row.id)
            // this.$router.push('/proContract/0/'+row.id)
            if(row.contractId && row.contractId!=''){
                this.$router.push('/purHead1/'+row.contractId)
            }else{
                this.$message.error('当前项目没有创建合同，请先创建合同！');
            }
        },
        // 新增的数据
        sumbitAddRow(formName) {
            var that = this;
            this.addForm.userId = this.$store.state.user.id
            this.addForm.userName = this.$store.state.user.name
            this.addForm.groupId = this.groupId
            this.addForm.areaId = this.selectedOptions.length>0?this.selectedOptions[this.selectedOptions.length-1]:''
            if(this.fileList.length>0){
                for(var i=0;i<this.fileList.length;i++){
                    if(i==0){
                        this.addForm.effectImage = this.fileList[i].baseUrl
                    }else{
                        this.addForm.effectImage += ','+this.fileList[i].baseUrl
                    }
                }
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(that.addForm.id==''){
                        myHttp.postEntProject(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.currentPage = 1;
                                that.getData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){});
                    }else{
                        myHttp.putEntProject(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.currentPage = 1;
                                that.getData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){});
                    }
                }
            });
        },
        //新增
        addFun(){
            this.addForm.id = ''
            this.addForm.name = ''
            this.addForm.address = ''
             this.addForm.projectStatus = '1'
            this.addForm.projectType = ''
            this.addForm.gpsPoint = ''
            this.addForm.maintenanceType='1'
            this.selectedOptions = []
            this.addFormVisible = true
            this.diaTitle = '项目创建'
             this.getUnit()
        },
        //修改
        modeFun(index,row){
            this.addFormVisible = true
            this.addForm.id = row.id
            this.addForm.name = row.name
            this.addForm.address = row.address
            this.addForm.note = row.note
            this.addForm.projectStatus =row.projectStatus
            this.addForm.projectType = row.projectType
            this.addForm.maintenanceType=row.maintenanceType
            this.addForm.projectHead = row.projectHead
            this.fileList = this.setImg(row.effectImage)
            this.diaTitle = '项目修改'
            this.addForm.gpsPoint = row.gpsPoint
            this.getUnit()
            this.setAreaFun(row.areaId)
        },

        handleRemove(file, fileList) {
            var list = []
            this.fileList = fileList
            // for(var i=0;i<this.imgList.length;i++){
            //     if(file.uid!=this.imgList[i].uid){
            //         list.push(this.imgList[i])
            //     }
            // }
            // this.imgList = list
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        fileSuccess(res,file,opt,index){
            var obj = {
                uid:file.uid,
                url:base.httpCtx+res.data.saveUrls,
                baseUrl:res.data.saveUrls,
            }
            this.fileList.push(obj)
        },
        getUnit(){
            var that = this
            myHttp.getDictByType({
                type: 'project_status'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.dictList || []
                    that.Status =list
                }
            })
            myHttp.getDictByType({
                type: 'project_type'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.dictList || []
                    that.Type =list
                }
            })
        },
        //
        //地图展示
        handler ({BMap, map}) {
            this.map = map;
            this.geoc = new BMap.Geocoder();
            this.local = new BMap.LocalSearch(map, {
                renderOptions: { map: map }
            });
            var that = this
            setTimeout(function(){
                if(that.addForm.gpsPoint && ''!=that.addForm.gpsPoint){
                    var obj = that.addForm.gpsPoint.split(',')
                    that.map.clearOverlays();
                    that.center = {lng: obj[0], lat: obj[1]}
                    var point = new BMap.Point(obj[0], obj[1]);
                    var marker = new BMap.Marker(point);
                    that.map.addOverlay(marker)
                }
            },10)
            // this.getData();
        },
        //地图点击方法
        getClickInfo (e) {
            this.map.clearOverlays();
            var point = new BMap.Point(e.point.lng, e.point.lat);
            var marker = new BMap.Marker(point);
            this.map.addOverlay(marker)
            this.addForm.gpsPoint = e.point.lng+','+e.point.lat;
        },
        //根据地址展示地图
        setMapPoint(){
            var val = this.addForm.address
            this.local.search(val);
        },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 85px );
        background: #fff;
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 140px );
        background: #fff;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
    .nijian-ent .el-input__inner{
        border:1px solid #DCDFE6
    }
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>